import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PATHS = { video: (id) => `/videos/${id}`, track: (id) => `/music/track/${id}`, album: (id) => `/music/album/${id}`, ep: (id) => `/music/album/${id}` };

// Destination for "Stream now": the first digital item of the order that we can open.
export const streamNowPath = (items) => {
  const it = items.find((i) => i.kind === "digital" && PATHS[i.content_type] && i.content_id);
  return it ? PATHS[it.content_type](it.content_id) : "/watch";
};

// On a page opened by "Stream now": start playback once the item is unlocked.
// Access can lag a moment behind payment, so re-check up to 3 times.
export const useStreamNowAutoplay = ({ ready, playable, reload, start }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const tries = useRef(0);
  const want = location.state?.streamNow;
  useEffect(() => {
    if (!want || !ready) return undefined;
    if (playable) {
      tries.current = 0;
      if (start) start();
      navigate(location.pathname + location.search, { replace: true, state: null });
      return undefined;
    }
    if (tries.current >= 3) return undefined;
    tries.current += 1;
    const tm = setTimeout(reload, 1500);
    return () => clearTimeout(tm);
  }, [want, ready, playable]); // eslint-disable-line react-hooks/exhaustive-deps
};
